import React from 'react';
import './about.css';
import Saddam from '../Assects/aboutSectionpic2.jpeg';

const About = () => {
  return (
    <section className="about">
      <div className="about-container">
        <div className="about-image">
          <img src={Saddam} alt="Saddam Anwar" />
        </div>
        <div className="about-content">
          <h2>Introduction</h2>
          <p>
            I'm <strong>Saddam Anwar</strong>, a passionate MERN Stack developer from Peshawar with over 2 years of experience.
            I specialize in building user-friendly, modern, and responsive interfaces with a strong focus on UI/UX design.
          </p>

          <h2>Skills</h2>
          <div className="skills">
            <div>
              <h4>Languages</h4>
              <ul>
                <li>HTML</li>
                <li>CSS</li>
                <li>JavaScript</li>
              </ul>
            </div>
            <div>
              <h4>Frameworks & Tools</h4>
              <ul>
                <li>React.js & Redux</li>
                <li>Node.js & Express.js</li>
                <li>MongoDB & Mongoose</li>
                <li>Tailwind CSS</li>
              </ul>
            </div>
          </div>

          <h2>Education</h2>
          <p>Currently studying at <strong>Islamia College Peshawar</strong>.</p>

          <h2>Experience</h2>
          <p>Completed 5+ freelance projects on <strong>Fiverr</strong>.</p>
        </div>
      </div>
    </section>
  );
};

export default About;
